import { lazy } from "react";

export default [
  {
    exact: true,
    path: ["/:customerName/approval/detail/:id"],
    component: lazy(() => import("src/views/arkadu/approval/ApprovalDetail")),
  },
  {
    exact: true,
    path: ["/:customerName/approval/:tabName", "/:customerName/approval/"],
    component: lazy(() => import("src/views/arkadu/approval/ApprovalIndex")),
  },
];
